import React from "react";

export default function Header() {
  const [open, setOpen] = React.useState(false);
  const [scrolled, setScrolled] = React.useState(false);

  React.useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { href: "#studio", label: "Lo Studio" },
    { href: "#materia", label: "Aree di Competenza" },
    { href: "#avvocati", label: "Gli Avvocati" },
    { href: "#impegno", label: "Impegno" },
    { href: "#sedi", label: "Sedi" },
    { href: "#contatti", label: "Contatti" },
  ];

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-40 transition-all duration-300 ${
        scrolled ? "bg-white/80 backdrop-blur-xl border-b border-black/5" : "bg-transparent"
      }`}
    >
      <div className="container-ed flex items-center justify-between h-16 md:h-20">
        <a href="#top" data-testid="logo-link" className="flex items-baseline gap-2">
          <span className="serif text-2xl md:text-3xl leading-none text-[#0F172A]">Scotti</span>
          <span className="text-[#A38A5A] serif text-xl">&amp;</span>
          <span className="serif text-2xl md:text-3xl leading-none text-[#0F172A]">Bava</span>
          <span className="hidden md:inline overline ml-3 text-[10px]">Studio Legale</span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.href.replace("#", "")}`}
              className="text-sm text-[#1C1917]/80 hover:text-[#0F172A] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a href="#contatti" data-testid="nav-cta" className="btn-primary !py-2 !px-4">
            Prenota consulenza
          </a>
        </nav>

        <button
          data-testid="menu-toggle"
          aria-label="Apri menu"
          className="md:hidden p-2 text-[#0F172A]"
          onClick={() => setOpen((o) => !o)}
        >
          <div className="w-6 h-[1px] bg-current mb-1.5" />
          <div className="w-6 h-[1px] bg-current mb-1.5" />
          <div className="w-4 h-[1px] bg-current ml-auto" />
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-white border-t border-black/5">
          <div className="container-ed py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mnav-${l.href.replace("#", "")}`}
                className="text-base text-[#1C1917]"
              >
                {l.label}
              </a>
            ))}
            <a href="#contatti" onClick={() => setOpen(false)} className="btn-primary mt-2 !justify-center">
              Prenota consulenza
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
